<template>
  <div class="login_contenter">
    <loginHeader></loginHeader>
    <div class="login_content" :class="{isPopFrame}">
      <div class="login_cont">
        <div class="login_form">
          <closeModalBtn ref="closeModalBtn"/>
          <div class="login_item">
            <div class="login_type">
              <span class="login_type_item active">{{ $t('huanYingZhuCe') }}</span>
            </div>
            <div class="login_form_cont">
              <el-form :rules="rules" ref="registerForm" :model="regForm" label-width="0px" size="medium">
                <el-form-item prop="regTel">
                  <el-input v-model="regForm.regTel" :placeholder="$t('ShouJiHaoYouXiang')" :readonly="btnStatus.registerBtn || forAutoComplete" auto-complete="false"></el-input>
                  <span class="item-error el-form-item__error" slot="error">
                    {{checkTelEmailErrorMsg}}
                    <a v-show="toLogina" @click="toLoginFn" style="cursor: pointer;">{{ $t('QuDengLu') }}&gt;&gt;</a>
                  </span>
                </el-form-item>
                <el-form-item prop="verificationCode" v-if="showCaptcha.register">
                  <el-input v-model="regForm.verificationCode" :placeholder="$t('TuXingYanZhengMa')" style="width: calc(100% - 150px);" :readonly="btnStatus.registerBtn || forAutoComplete" maxlength="6" auto-complete="false"></el-input>
                  <img class="imgCode" @click="loginChangeCodeFn('regNoteImgCode')" :src="imgCodeData.regNoteImgCode" :alt="$t('YanZhengMa')" :title="$t('DianJiQieHuanYanZhengMa')">
                </el-form-item>
                <el-form-item prop="telVerificationCode">
                  <el-input v-model="regForm.telVerificationCode" :placeholder="$t('YanZhengMa')" maxlength="6" :readonly="btnStatus.registerBtn || forAutoComplete" auto-complete="false"></el-input>
                  <el-button class="getNoteCodeBtn" type="text" @click="getNoteCode" :disabled="noteCodeBtn">{{telCodeText}}</el-button>
                </el-form-item>
                <el-form-item prop="regPwd">
                  <el-input v-model="regForm.regPwd" :placeholder="$t('MiMa')" :readonly="btnStatus.registerBtn || forAutoComplete" :type="!showPwdIcon?'password':'text'"  :clearable="windowInnerWidth > 499" auto-complete="false">
                    <i slot="suffix" class="el-input__icon iconfont" @click="showPwdFn" :class="{'yyq-icon-hide': !showPwdIcon, 'yyq-icon-view': showPwdIcon}"></i>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="regForm.invitationCode" :readonly="btnStatus.registerBtn" :placeholder="$t('YaoQingMaFeiBiTian')" clearable auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item prop="checked" class="protocol">
                  <el-checkbox v-model="regForm.checked" :disabled="btnStatus.registerBtn">
                    <i18n path="WoYiYueDuBingTongYi">
                      <template #tos>
                        <el-link class="sy_reg_atc" type="primary" :href="$urls.dtranxUrl + '/home/UserAgreement?locale=' + language" target="_blank">
                          {{ $t('YongHuXieYi') }}
                        </el-link>
                      </template>
                      <template #privacy>
                        <el-link type="primary" class="sy_reg_atc" :href="$urls.dtranxUrl + '/home/PrivacyPolicy?locale=' + language" target="_blank">
                          {{ $t('YinSiShengMing') }}
                        </el-link>
                      </template>
                    </i18n>
                  </el-checkbox>
                </el-form-item>
                <el-form-item class="protocol">
                  <el-checkbox v-model="isKeepMore" :disabled="btnStatus.loginNoteBtn">{{ $t('30TianNeiJiZhuWo') }}</el-checkbox>
                </el-form-item>
                <el-form-item size="large">
                  <el-button type="primary" class="loginBtn" @click="registerSubmit" :loading="btnStatus.registerBtn">{{ $t('ZhuCeBingDengLu') }}</el-button>
                </el-form-item>
              </el-form>
              <div class="register_title">{{ $t('YiGeZhangHaoKeDengLuSuoYouShuYiQiXiaChanPin') }}</div>
            </div>
            <div class="sy_login_bottom sy_text_c">
              <i18n path="YiYouZhangHao">
                <template #link>
                  <a type="primary" @click="toPath('/')" href="javascript:;">{{ $t('QuDengLu') }} <i class="el-icon-right"></i></a>
                </template>
              </i18n>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <loginFooter></loginFooter>-->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import loginHeader from '@/components/loginPublic/loginHeader'
import loginFooter from '@/components/loginPublic/loginFooter'
export default {
  name: 'register',
  components: { loginHeader, loginFooter },
  data () {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuTuXingYanZhengMa')))
      } else if (!(/^\S{4}$/).test(value)) {
        callback(new Error(this.$t('TuXingYanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuYanZhengMa')))
      } else if (!(/^[0-9]{6}$/).test(value)) {
        callback(new Error(this.$t('YanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var checktel = (rule, value, callback) => {
      this.toLogina = false
      if (!value) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuShouJiHao')
        return callback(new Error(this.checkTelEmailErrorMsg))
      }
      if (!(/^1[3-9][0-9]{9}$/).test(value)) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuZhengQueDeShouJiHao')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else {
        this.getUserIsExistFn(value).then((res) => {
          if (res.success) {
            callback()
            this.toLogina = false
          } else {
            this.checkTelEmailErrorMsg = this.$t('GaiShouJiHaoYiZhuCe')
            callback(new Error(this.checkTelEmailErrorMsg))
            this.toLogina = true
          }
        }).catch(() => {
          callback()
          this.toLogina = false
        })
      }
    }
    var checkTelEmail = (rule, value, callback) => {
      this.toLogina = false
      if (!value) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuShouJiHaoYouXiang')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else if (!(/^1[3-9][0-9]{9}$/).test(value) && !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuZhengQueDeShouJiHaoYouXiang')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else {
        this.getUserIsExistFn(value).then((res) => {
          if (res.success) {
            callback()
            this.toLogina = false
          } else {
            this.checkTelEmailErrorMsg = this.$t('GaiShouJiHaoYouXiangYiZhuCe')
            callback(new Error(this.checkTelEmailErrorMsg))
            this.toLogina = true
          }
        }).catch(() => {
          callback()
          this.toLogina = false
        })
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuMiMa816WeiDeMiMaShuZiZiMuZiFuZhiShaoBaoHanLiangZhong')))
      } else if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z-`=\[\];',.~!@#$%^&*()_+|{}:"?]{8,16}$/).test(value)) {
        callback(new Error(this.$t('QingShuRuMiMa816WeiDeMiMaShuZiZiMuZiFuZhiShaoBaoHanLiangZhong')))
      } else {
        this.getUserCheckPsdFn(value).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(new Error(this.$t('QingShuRuMiMa816WeiDeMiMaShuZiZiMuZiFuZhiShaoBaoHanLiangZhong')))
          }
        }).catch(() => {
          callback()
        })
      }
      // else if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/).test(value)) {
      //   callback(new Error('请输入密码(8-16位，必须包含数字、字母)'))
      // }
    }
    const checked = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingGouXuanTongYiXiangGuanTiaoKuan')))
      } else {
        callback()
      }
    }
    return {
      codeTimer: 0,
      loginType: 'wx',
      isKeepMore: false,
      toLogina: false,
      forAutoComplete: true,
      regForm: {
        regTel: '',
        verificationCode: '',
        telVerificationCode: '',
        regPwd: '',
        invitationCode: '',
        checked: false
      },
      showPwdIcon: false,
      noteCodeInterval: null,
      noteCodeBtn: false,
      rules: {
        regTel: [
          { validator: checkTelEmail, trigger: 'blur' }
        ],
        verificationCode: [
          { validator: validatePass, trigger: 'blur' }
        ],
        telVerificationCode: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        regPwd: [
          { validator: validatePwd, trigger: 'blur' }
        ],
        checked: [
          { type: 'boolean', required: true, validator: checked, trigger: 'change' }
        ]
      },
      checkTelEmailErrorMsg: '',
      windowInnerWidth: 1200
    }
  },
  methods: {
    ...mapMutations(['showMsg']),
    ...mapActions(['loginChangeCodeFn', 'getNoteCodeFn', 'registerLoginFn', 'getUserIsExistFn', 'getUserCheckPsdFn', 'pwdLoginFn']),
    showPwdFn () {
      this.showPwdIcon = !this.showPwdIcon
    },
    toLoginFn () {
      this.$router.push('/?tel=' + encodeURIComponent(this.regForm.regTel))
    },
    getTelCode () {
      this.NoteCodeData.regNoteCodeKey = ''
      this.getNoteCodeFn({
        imageCode: this.regForm.verificationCode,
        imageCodeKey: this.imgCodeData.regNoteImgCodeKey,
        account: this.regForm.regTel,
        origin: 'register'
      }).then((response) => {
        this.NoteCodeData.regNoteCodeKey = response.data.SMSCodeKey
        this.codeTimer = 120
        this.noteCodeBtn = true
        this.noteCodeInterval = setInterval(() => {
          if (this.codeTimer > 0) {
            this.codeTimer--
          } else {
            this.noteCodeBtn = false
            clearInterval(this.noteCodeInterval)
          }
        }, 1000)
      }).catch((response) => {
        this.loginChangeCodeFn('regNoteImgCode')
        this.noteCodeBtn = false
      })
    },
    getNoteCode () {
      this.noteCodeBtn = true
      this.$refs.registerForm.validateField('regTel', (val, item) => {
        // console.log(val, new Date().getTime())
        if (!val) {
          if (this.showCaptcha.register) {
            this.$refs.registerForm.validateField('verificationCode', (val, item) => {
              // console.log(val)
              if (!val) {
                this.getTelCode()
              } else {
                this.noteCodeBtn = false
              }
            })
          } else {
            this.getTelCode()
          }
        } else {
          this.noteCodeBtn = false
        }
      })
    },
    registerSubmit () {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          let regData = {
            userId: '',
            userAccount: this.regForm.regTel,
            userPassword: this.regForm.regPwd,
            code: this.regForm.telVerificationCode,
            codeKey: this.NoteCodeData.regNoteCodeKey,
            inviteCode: this.regForm.invitationCode,
            registerSource: this.windowInnerWidth <= 499 ? 'H5' : 'PC',
            userEmail: '',
            userWxopenid: '',
            source: this.loginSource.buryingPoint
          }
          this.registerLoginFn(regData).then((res) => {
            let pwdData = {
              userAccount: this.regForm.regTel,
              password: this.util.encodeToBase64(this.regForm.regPwd),
              code: '',
              codeKey: '',
              isKeepMore: this.isKeepMore
            }
            this.pwdLoginFn(pwdData).then((resl) => {
              let token = resl.data.Authentication
              this.setCookie('DTRANXTOKEN', token)
              if (this.isPopFrame) {
                this.$refs.closeModalBtn.sendMsgOfSuccess(token)
              } else {
                window.location.href = `${this.loginSource.url}`
              }
            }).catch(() => {})
          }).catch(() => {})
        } else {
          return false
        }
      })
    },
    toPath (item) {
      this.$router.push(item)
    }
  },
  mounted () {
    let regTel = this.$route.query.tel
    if (regTel) {
      this.regForm.regTel = regTel
    }
    let that = this
    window.onkeydown = function (event) {
      let e = event || window.event
      if (e.type === 'keydown' && (e.code === 'Enter' || e.code === 'NumpadEnter')) {
        e.preventDefault()
        if (!that.btnStatus.registerBtn) {
          that.registerSubmit()
        }
      }
    }
  },
  destroyed () {
    window.onkeydown = null
    clearInterval(this.noteCodeInterval)
  },
  created () {
    this.windowInnerWidth = window.innerWidth
    setTimeout(() => {
      this.forAutoComplete = false
      this.regForm.telVerificationCode = ''
      this.regForm.regPwd = ''
    }, 500)
    let icd = this.$route.query
    if (icd && icd.invite) {
      this.regForm.invitationCode = icd.invite
    }
    window.onresize = () => {
      this.windowInnerWidth = window.innerWidth
      if (this.windowInnerWidth <= 499) {
        this.loginType = 'tel'
        this.loginChangeCodeFn('loginNoteImgCode')
      }
    }
  },
  computed: {
    ...mapState({
      isPopFrame: state => state.publicModules.isPopFrame,
      language: state => state.publicModules.language,
      loginSource: state => state.publicModules.loginSource,
      modal: state => state.loginPublic.modal,
      imgCodeData: state => state.loginPublic.imgCodeData,
      NoteCodeData: state => state.loginPublic.NoteCodeData,
      btnStatus: state => state.loginPublic.btnStatus,
      showCaptcha: state => state.loginPublic.showCaptcha
    }),
    telCodeText () {
      if (this.codeTimer > 0) {
        return this.$t('TimerMiaoHouZhongXinFaSong', [this.codeTimer])
      }
      return this.$t('HuoQuYanZhengMa')
    }
  }
}
</script>

<style scoped lang="scss">
.login_content {
  .login_cont {
    .register_title{
      font-size: 14px;
      color: var(--font-color2);
      text-align: center;
    }
  }
}
@media (min-width: 500px) {
  .login_contenter{
    .login_content{
      min-height: 858px;
      &.isPopFrame{
        min-height: 730px;
      }
    }
  }
}
@media (max-width: 499px) {
  .login_contenter{
    .login_content{
      .login_cont{
        .login_form{
          .login_form_cont{
            min-height: 527px;
          }
        }
      }
    }
  }
}
</style>
